import { createApp } from 'vue'
import App from './App.vue'; //  для работы с данными через js
//import App from "./AppPHP.vue"; //  для работы с данными через php

createApp(App).mount('#app')
